<div *ngIf="statusHistorysData.length > 0 || !configCard?.datalessConfig?.isHideEmptyCard" class="status-history-container">
  <div class="flex-grow overflow-hidden">
    <ptg-list-display-box
      [title]="cardTitle"
      pageName="Data"
      [isLoading]="isLoading"
      [dataTable]="statusHistorysData"
      [columns]="statusHistorysData.length > 0 || configCard?.datalessConfig?.listDisplayPreferenceType !== LIST_DISPLAY_PREFERENCE_TYPE.Hide ? columns : []"
      [sortInfo]="sortInfo"
      [lengthPg]="lengthPg"
      [pageSize]="pageSize"
      [pageNumber]="pageNumber"
      [currentRowIndex]="currentRowIndex"
      [paginable]="statusHistorysData.length> 0 || configCard?.datalessConfig?.listDisplayPreferenceType !== LIST_DISPLAY_PREFERENCE_TYPE.Hide"
      [isHideNotFoundMessage]="configCard?.datalessConfig?.listDisplayPreferenceType === LIST_DISPLAY_PREFERENCE_TYPE.Hide || 
        configCard?.datalessConfig?.listDisplayPreferenceType === LIST_DISPLAY_PREFERENCE_TYPE.DisplayColumnHeaders"
      (changePage)="changePage($event)"
      (sortChange)="sortChange($event)"
      (selectRow)="selectRow($event)"
    >
    <ng-container>
      <div>
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            aria-label="Icon-button with a menu"
            class="group-button ignore-row"
          >
            <mat-icon class="ignore-row">more_horiz</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="addStatusHistory()">
              <mat-icon class="member-section-action-icon">add</mat-icon>
              <span class="label-icon">Add New</span>
            </button>
            <button
              mat-menu-item
              *ngIf="statusHistorysData?.length"
              (click)="manageStatusHistory()"
            >
              <mat-icon class="member-section-action-icon"> list_alt </mat-icon>
              <span class="label-icon">Manage</span>
            </button>
          </mat-menu>
      </div>
    </ng-container>
  </ptg-list-display-box>
  </div>
</div>
